<template>
    <div>
        <div class="card-mercado-pago">
            <!-- <h2 style="color: black;">valor = {{total.toString() }}</h2> -->
            <div v-if="pix_payment_id != null">
                <mp-status-screen-pix 
                :paymentId="pix_payment_id" 
                :pix_data="pix_data" 
                :cnpj="this.$store.state.cnpj"
                :numeroEmpresaFK="this.$store.state.numeroEmpresaFK"
                @onApproved="onPixApproved"
                />
            </div>
            <div id="paymentBrick_container" v-if="pix_payment_id == null">
                <!-- brick do mercado pago aqui  -->
            </div>
        </div>
    </div>
</template>

<script>


import { apiMercadoPagoCriarPagamento } from '@/api/ApiMercadoPago'
import Swal from 'sweetalert2'
import MpStatusScreenPix from './MpStatusScreenPix.vue'
import StoragePedidos from '@/utils/guardarPedidoStorage';
export default {
    components: { MpStatusScreenPix },
    name: "MpPagamento",
    created() {
        this.mp()

        console.log(" i have been created!!!!!!")
    },
    
    mounted( ) {
        
    },
    
    props: {
        total: Number,
        pedido: Object
    },
    data() {
        return {
             public_key: this.$store.state.mp_public_key,
             pix_payment_id : null,
             pix_data : null,

             /** aqui vamos mandar pra api se foi PIX, DEBITO ou CREDITO */
             payment_method_id: null,

             resposta_mercado_pago: null,
        }
    },
    methods: {
        printar() {
            console.log(window)
        },



        /**
         * Callback do [mp-status-screen-pix] para saber quando o pix foi pago e aprovado.
         */
        onPixApproved() {
            StoragePedidos.deletar();
            this.pagamentoFeitoComSucesso();
        },

        /**
         * Volta para o parent com o pagamento feito, pronto para enviar o pedido
         */
        enviarPedidoPagamentoPix() {
            this.$emit("onSubmit", {
                qr_code: this.pix_data,
                payment_id: this.pix_payment_id,
                payment_method_id: this.payment_method_id,
                data_pedido: new Date(),
                resposta_mercado_pago: this.resposta_mercado_pago,
            })
        },

        /**
         */

        /**
         * Funcao chamada quando o botao "PAGAR" no bricks do mercado pago for pressionado
         * @param {*} formData Dados do retorno do pagamento apos ser enviado para a api pelo bricks do mercado pago
         */
        onSubmitMercadoPago(payment_method, formData) {
            if (formData.payment_type_id == null) {
                formData.payment_type_id = payment_method
            }
            
            console.log("pagamento sendo criado assim")
            console.log("payment_method")
            console.log(payment_method)
            console.log("formData")
            console.log(formData)
            apiMercadoPagoCriarPagamento(this.$store.state.cnpj, this.$store.state.numeroEmpresaFK, formData)
              .then(res => {

                this.resposta_mercado_pago = res;
                console.log("pagamento criado abaixo")
                console.log(res)
                
                
                this.payment_method_id = payment_method;

                console.log("payment_method")
                console.log(payment_method)

                // TRATAR PIX CORRETAMENTE
                if (payment_method == "bank_transfer") {
                    const pagamentoCriado = res?.id && res?.point_of_interaction?.transaction_data?.qr_code;
                    console.log("pagamentoCriado no pix")

                    if (!pagamentoCriado) {
                        Swal.fire({
                            title: "Erro no pagamento",
                            text: "Não foi possível gerar o QR Code PIX"
                        }).then(() => {
                            this.$emit("onError")
                        })
                        return;
                    }

                    this.lidarPagamentoPix(res);
                    return;
                }

                // TRATAR CARTAO
                else {
/**

status: "rejected"
status_detail: "cc_rejected_high_risk"

 */
                    console.log("pagamentoCriado no CARTAO")
                    if (res.status != "approved") {
                        Swal.fire({
                            title: "Erro no pagamento",
                            text: "Há algo errado com os dados do cartão, ou o pagamento foi recusado. Por favor, tente novamente."
                        }).then(() => {
                            this.$emit("onError")
                        })
                        return;
                    }

                    this.enviarPedidoPagamentoPix();
                }



            })
        },

        /**
         * Aqui vamos setar os dados do pagamento pix para exibir o qr code 
         * 
         * vamos gerar o [pix_data] e o [pix_payment_id]
         * 
         * e dai ja vamos mandar o pedido pra Api, com esses dados juntos.
         * A Api vai checar o status do pagamento PIX
         * 
         * @param res response da funcao @apiMercadoPagoCriarPagamento
         */
        lidarPagamentoPix(res) {
            console.log("Resposta do pagamento pix:");
            console.log("Resposta do pagamento pix:", res);


            this.pix_data = res?.point_of_interaction?.transaction_data?.qr_code;
            this.pix_payment_id = res.id;

            this.enviarPedidoPagamentoPix();
            this.localstorage();
        }, 

        /**
         * vamos guardar esse pedido e o qrcode no local storage.
         */
         localstorage() {
            StoragePedidos.salvar(
                this.$store.state.cnpj, 
                this.$store.state.numeroEmpresaFK, 
                this.pix_payment_id, 
                this.pix_data, 
                this.pedido,
            )
        },

        /**
         * traz os metodos de pagamento que o mercado pago vai aceitar baseado na configuracao no allfood se o cliente aceita pix e/ou cartao de credito no mercadopago
         */
        mpPaymentMethods() {
            let metodos = {
                // bankTransfer: "pix", // vai ser adicionado nas linhas abaixo
                // creditCard: "all", // vai ser adicionado nas linhas abaixo
                minInstallments: 1,
                maxInstallments: 1,
                // ticket: "all", // boleto bancario
                // mercadoPago: "all",
                // debitCard: "all",
            }
            if (this.$store.state.mp_tem_pix == true) {
                metodos.bankTransfer = "pix"
            }
            if (this.$store.state.mp_tem_cartao == true) {
                metodos.creditCard = "all"
            }
            return metodos;    

        },


        /**
         * funcao que vai renderizar o brick do mercado pago
         */
        mp() {
            console.log("^mercado pago criado aqui e o valor eh de" , this.total)
            let amount = this.total;
            let public_key = this.public_key;
            
            const mp = new window.MercadoPago(public_key);

            const bricksBuilder = mp.bricks();

            const renderPaymentBrick = async (bricksBuilder) => {
                const settings = {

                    initialization: {
                        /*
                            "amount" é o valor total a ser pago por todos os meios de pagamento
                            com exceção da Conta Mercado Pago e Parcelamento sem cartão de crédito, que tem seu valor de processamento determinado no backend através do "preferenceId"
                        */
                        amount: amount,
                        preferenceId: "<PREFERENCE_ID>",
                    },

                    customization: {

                        visual: {
                            style: {
                                customVariables: {
                                    
                                },
                            },
                        },

                        paymentMethods: this.mpPaymentMethods(),
                        // paymentMethods: {
                        //     // ticket: "all", // boleto bancario
                        //     bankTransfer: "pix",
                        //     creditCard: "all",
                        //     // debitCard: "all",
                        //     minInstallments: 1,
                        //     maxInstallments: 1,
                        //     // mercadoPago: "all",
                        // },

                    },

                    callbacks: {
                        onReady: () => {
                        /*
                            Callback chamado quando o Brick estiver pronto.
                            Aqui você pode ocultar loadings do seu site, por exemplo. 
                        */
                        },
                        onSubmit: ({ selectedPaymentMethod, formData }) => {
                            console.log("selectedPaymentMethod")
                            console.log(selectedPaymentMethod)
                            console.log("formData")
                            console.log(formData)
                            this.onSubmitMercadoPago(selectedPaymentMethod,formData)
                        },
                        
                        onError: (error) => {
                            // callback chamado para todos os casos de erro do Brick
                            console.log("Deu erro no bricks");
                            console.log(error);
                            console.error(error);
                        },
                    },
                };
                try {
                    window.paymentBrickController = await bricksBuilder.create(
                        "payment",
                        "paymentBrick_container",
                        settings
                    );
                } catch (error) {
                    // alert(error);
                    console.error("erro na criacao do bricks do mercado pago")
                    console.erro("Provavelmente esse erro ocorreu por nao ter entrega para este bairro, entao o bricks nao deve aparecer mesmo.")
                    console.error(error)
                }
            };

            renderPaymentBrick(bricksBuilder);
        }
    }
}
</script>

<style scoped>

.card-mercado-pago{
    margin-inline: 15px;
    border-radius: 5px;
    background: white;
}

#paymentBrick_container {
    margin-inline: 15px;
}

</style>